import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

//Componentes
//import Login from './components/admin/Login.vue';

const page="./components/page/";

const MyRouter = new VueRouter({
  	routes:[
	    // { path: '/', name: 'preHomePage', component: require(page+'home/pre-home.vue').default },
	    { path: '/', component: require(page+'home/home.vue').default },
	    { path: '/guarantee', component: require(page+'guarantee/index.vue').default, meta:{ title:"Guarantee" } },
      { path: '/about-us', component: require(page+'company/index.vue').default, meta:{ title:"About us" }},
      
      { path: '/contact', component: require(page+'contact/index.vue').default, meta:{ title:"Contact" }},
      
      { path: '/products', component: require(page+'products/results.vue').default, meta:{ title:"Products" }},
      { path: '/sale', component: require(page+'products/sale.vue').default, meta:{ title:"Sale" }},
      { path: '/product/:id', component: require(page+'products/description.vue').default, meta:{ title:"Producto" }},
      
      { path: '/search', component: require(page+'products/search.vue').default, meta:{ title:"Search" }},

      { path: '/privacy-policy', component: require(page+'text-pages/aviso.vue').default, meta:{ title:"Privacy Policy" } },
      { path: '/terms-of-service', component: require(page+'text-pages/terminos.vue').default, meta:{ title:"Terms of Service" } },

      { path: '/cart/:step?', component: require(page+'carrito/index.vue').default, meta:{title:"Mi carrito de compras"}},
      // { path: '/historial-de-compras', component: require(page+'carrito/historial.vue').default, meta:{title:"Mi historial de compras"}},
      // { path: '/mis-favoritos', component: require(page+'carrito/mis-favoritos.vue').default, meta:{title:"Mis favoritos"}},

      // { path: '/afiliate', component: require(page+'join/index.vue').default, meta:{title:"Afíliate"}},
      { path: '/login', component: require(page+'user-access/login.vue').default, meta:{title:"Iniciar sesión"}},
      { path: '/recuperar-contrasena', component: require(page+'user-access/reset-password.vue').default, meta:{title:"Recuperar contraseña"}},
      // { path: '/registrarse', component: require(page+'user-access/register.vue').default, meta:{title:"Registrarse"}},

      { path: '/usuario', component: require(page+'usuario-cuenta/index.vue').default, meta:{ title: 'My account' },
  			children: [
  			{
  				path: '/',
  				component: require(page+'usuario-cuenta/mis-datos.vue').default,
  				meta:{ title: 'My details' }
  			},
  			{
  				path: 'contrasena',
  				component: require(page+'usuario-cuenta/contrasena.vue').default,
  				meta:{ title: 'Change password' }
  			},
        // {
        //     path: 'historial-compras',
        //     component: require(page+'usuario-cuenta/historial-compras.vue').default,
        //     meta:{ title: 'My orders' }
        // },
        {
            path: 'pedido/:id',
            component: require(page+'usuario-cuenta/orderdetails.vue').default,
            meta:{ title: 'My orders' }
        },
  	  	]
  		},

	    // { path: '/checkout', component: require(page+'checkout.vue').default, meta:{title:"Checkout"}},
	  ]
});

MyRouter.beforeEach((to, from, next) => {
	window.scrollTo(0,0);
	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		window.app.__vue__.$refs.loadingBar.start();
	}
	next();
});

MyRouter.afterEach((to, from) => {

	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		setTimeout(()=>{
			window.app.__vue__.$refs.loadingBar.done();
		},500);
	}


});

//Titulos del website
import VueDocumentTitlePlugin from "vue-document-title-plugin";
Vue.use(VueDocumentTitlePlugin, MyRouter,
	{ defTitle: "DEC Industries", filter: (title)=>{ return title+" - DEC Industries"; } }
);

// export {routes};
export default MyRouter;
